import HeaderBodyCopy from './component.jsx'
export default HeaderBodyCopy
